import React from "react";
// import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import useEditCategory from "../../../controllers/useEditCategory";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../feature-module/components/errorMessage";
import InputField from "../../../feature-module/components/InputField";

const EditCategoryList = ({ rowData, refetch }) => {
  const { values, functions } = useEditCategory(rowData, refetch);

  return (
    <div>
      {/* Edit Category */}
      <div className="modal fade" id="edit-category">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Edit Category</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={functions.onCancel}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form>
                    <div className="mb-3">
                      <Controller
                        name="name"
                        control={values.control}
                        rules={{ required: "Category is required" }}
                        render={({ field }) => (
                          <InputField
                            label="Category"
                            type="text"
                            value={field?.value}
                            {...field}
                          />
                        )}
                      />
                      <ErrorMessage error={values.errors.name?.message} />
                    </div>
                    {/* <div className="mb-3">
                      <Controller
                        name="description"
                        control={values.control}
                        rules={{ required: "Description is required" }}
                        render={({ field }) => (
                          <InputField
                            label="Description"
                            type="text"
                            value={field?.value}
                            {...field}
                          />
                        )}
                      />
                      <ErrorMessage
                        error={values.errors.description?.message}
                      />
                    </div> */}
                    <div className="mb-0">
                      <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                        <span className="status-label">Status</span>
                        <Controller
                          name="is_active"
                          control={values.control}
                          render={({ field }) => {
                            console.log("FIELDS", field);
                            return (
                              <>
                                <input
                                  type="checkbox"
                                  id="edit-categoryStatus"
                                  className="check"
                                  checked={field.value}
                                  onChange={(e) => {
                                    console.log("EEEE", e);
                                    field.onChange(e.target.checked);
                                    console.log("FIELDS", field.value);
                                  }} // Update form state on change
                                />
                                <label
                                  htmlFor="edit-categoryStatus"
                                  className="checktoggle"
                                />
                              </>
                            );
                          }}
                        />
                        {/* <input
                          type="checkbox"
                          id="user3"
                          className="check"
                          defaultChecked="true"
                        />
                        <label htmlFor="user3" className="checktoggle" /> */}
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                        onClick={functions.onCancel}
                      >
                        Cancel
                      </button>
                      <button
                        to="#"
                        className="btn btn-submit"
                        disabled={values.loading}
                        onClick={functions.onSubmit}
                      >
                        {values.loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Saving...
                          </>
                        ) : (
                          "Save Changes"
                        )}
                        {/* Save Changes */}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Category */}
    </div>
  );
};

EditCategoryList.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    is_active: PropTypes.bool.isRequired,
    // created_at: PropTypes.string.isRequired,
  }).isRequired,
  refetch: PropTypes.func.isRequired,
};

export default EditCategoryList;
